"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var ScoreCard = function ScoreCard(_a) {
  var hint = _a.hint,
    colorClass = _a.colorClass,
    value = _a.value,
    factors = _a.factors,
    descriptions = _a.descriptions;
  return React.createElement("div", {
    className: 'ths-score-card'
  }, React.createElement("div", {
    className: 'score-overview-container'
  }, React.createElement("div", {
    className: 'score-circle-container'
  }, React.createElement("div", {
    className: 'score-circle score-' + colorClass
  }, value)), React.createElement("div", {
    className: 'score-level-title'
  }, descriptions.score.display, React.createElement("i", {
    "data-toggle": "tooltip",
    title: hint,
    className: 'fa fa-question-circle'
  }))), React.createElement("div", {
    className: 'score-details-container'
  }, React.createElement("div", {
    className: 'score-level-container'
  }, React.createElement("div", {
    className: 'score-level-description'
  }, descriptions.score.description)), React.createElement("div", {
    className: 'score-factor-details'
  }, React.createElement("div", {
    className: 'score-factors-title'
  }, "Why were points deducted?"), React.createElement("ul", {
    className: 'score-factor-list'
  }, descriptions.factors.map(function (factorDescription, key) {
    return React.createElement("li", {
      key: key
    }, factorDescription);
  })))));
};
exports.ScoreCard = ScoreCard;
ScoreCard.defaultProps = {
  descriptions: {
    factors: [],
    score: {
      display: '',
      description: ''
    }
  }
};